export const gameConstants = {

    FETCH_GAME_REQUEST: 'FETCH_GAME_REQUEST',
    FETCH_GAME_SUCCESS: 'FETCH_GAME_SUCCESS',
    FETCH_GAME_FAILURE: 'FETCH_GAME_FAILURE',

    CREATE_GAME_REQUEST: 'CREATE_GAME_REQUEST',
    CREATE_GAME_SUCCESS: 'CREATE_GAME_SUCCESS',
    CREATE_GAME_FAILURE: 'CREATE_GAME_FAILURE',

    UPDATE_GAME_REQUEST: 'UPDATE_GAME_REQUEST',
    UPDATE_GAME_SUCCESS: 'UPDATE_GAME_SUCCESS',
    UPDATE_GAME_FAILURE: 'UPDATE_GAME_FAILURE',

    UPDATE_SEQUENCE_REQUEST: 'UPDATE_SEQUENCE_REQUEST',
    UPDATE_SEQUENCE_SUCCESS: 'UPDATE_SEQUENCE_SUCCESS',
    UPDATE_SEQUENCE_FAILURE: 'UPDATE_SEQUENCE_FAILURE',

}